

// 接口服务器地址
export const API_BASEURL = '/operator';

// 本地化键名
export const LOCAL_CONST_NAME = 'sc-client-exhibition';//'sc_manager_front';//'sc-client-exhibition';

// 是否开启redux打印
export const REDUX_LOG_OPEN = true;

export const PHONEREG = /^1[3-9]\d{9}$/

// 门店二维码服务器地址
export const API_EWM_BASEURL = (function() {
	let urlStr = '';
	if (process.env.NODE_ENV === 'development') {
        console.log('开发环境')
		urlStr = 'wx.rongdaufun.com'
	} else {
		console.log('生产环境');
		urlStr = document.domain;
	}
	return urlStr
})()

let constantObj = {
	API_BASEURL,
	LOCAL_CONST_NAME,
	REDUX_LOG_OPEN,
	PHONEREG,
	API_EWM_BASEURL,
}

export default constantObj
